import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

//Third_party_Module
import { ChartsModule } from 'ng2-charts';
import { MyDatePickerModule } from 'mydatepicker';
import { SelectModule } from 'angular2-select';
import { MasonryModule } from 'angular2-masonry';
import { TooltipModule } from 'ng2-tooltip';
//Routing
import { mainRouting } from '../main.routes';
//Component
import { ReportsComponent } from './reports.component';
import { ResourceAllocationComponent } from './components/resource-allocation/resource-allocation.component';
import { ResourceAvailabilityComponent } from './components/resource-availability/resource-availability.component';
import { TimesheetComponent } from './components/timesheet/timesheet.component';
import { IncomeComponent } from './components/income/income.component';
import { AttendanceComponent } from './components/timesheet/attendance/attendance.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    
    ChartsModule,
    MyDatePickerModule,
    MasonryModule,
    SelectModule,
    TooltipModule,
     
    mainRouting
  ],
  declarations: [
    ReportsComponent,
    ResourceAllocationComponent,
    ResourceAvailabilityComponent,
    TimesheetComponent,
    IncomeComponent,
    AttendanceComponent
  ]
})
export class ReportsModule { }


// WEBPACK FOOTER //
// ./src/app/modules/reports/reports.module.ts